import Vue from "vue";
import Vuetify, {
  VBanner,
  VBottomNavigation,
  VExpandTransition,
  VChip,
  VFileInput,
  VDatePicker,
  VBtnToggle,
  VMenu,
  VTabsItems,
  VListItemAvatar,
  VTabsSlider,
  VTab,
  VTabs,
  VListItemGroup,
  VSkeletonLoader,
  VSlideXTransition,
  VProgressLinear,
  VCheckbox,
  VAvatar,
  VParallax,
  VMain,
  VDataIterator,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelHeader,
  VExpansionPanelContent,
  VItem,
  VItemGroup,
  VSelect,
  VBadge,
  VListItemAction,
  VListItemActionText,
  VListGroup,
  VNavigationDrawer,
  VListItemIcon,
  VFlex,
  VLayout,
  VForm,
  VCombobox,
  VSparkline,
  VCarousel,
  VCarouselItem,
  VAppBarNavIcon,
  VToolbarTitle,
  VDataTable,
  VToolbar,
  VSwitch,
  VSimpleTable,
  VTextField,
  VTextarea,
  VIcon,
  VAppBar,
  VContent,
  VContainer,
  VFooter,
  VList,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VListItemContent,
  VCard,
  VCardSubtitle,
  VRow,
  VCol,
  VImg,
  VCardTitle,
  VBtn,
  VCardActions,
  VCardText,
  VProgressCircular,
  VSpacer,
  VDialog,
  VDivider,
  VAlert,
  VApp,
  VOverlay,
} from "vuetify/lib";

import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader

Vue.use(Vuetify, {
  components: {
    VBanner,
    VBottomNavigation,
    VExpandTransition,
    VChip,
    VFileInput,
    VDatePicker,
    VBtnToggle,
    VMenu,
    VTabsItems,
    VListItemAvatar,
    VTabsSlider,
    VTab,
    VTabs,
    VListItemGroup,
    VSkeletonLoader,
    VSlideXTransition,
    VProgressLinear,
    VCheckbox,
    VAvatar,
    VMain,
    VDataIterator,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VItem,
    VItemGroup,
    VBadge,
    VSelect,
    VListItemAction,
    VListItemActionText,
    VListGroup,
    VNavigationDrawer,
    VListItemIcon,
    VFlex,
    VLayout,
    VForm,
    VCombobox,
    VSparkline,
    VCarousel,
    VCarouselItem,
    VToolbarTitle,
    VAppBarNavIcon,
    VDataTable,
    VToolbar,
    VSwitch,
    VSimpleTable,
    VTextField,
    VTextarea,
    VIcon,
    VAppBar,
    VContent,
    VContainer,
    VFooter,
    VCard,
    VCardSubtitle,
    VList,
    VListItem,
    VListItemTitle,
    VListItemSubtitle,
    VListItemContent,
    VRow,
    VCol,
    VImg,
    VCardTitle,
    VBtn,
    VCardActions,
    VCardText,
    VProgressCircular,
    VSpacer,
    VDialog,
    VDivider,
    VAlert,
    VApp,
    VParallax,
    VOverlay,
  },
});

export default new Vuetify({
  themes: {
    light: {
      primary: "#4caf50",
      secondary: "#4caf50",
      tertiary: "#495057",
      accent: "#82B1FF",
      error: "#f55a4e",
      info: "#00d3ee",
      success: "#5cb860",
      warning: "#ffa21a",
      general: "#2196F3",
    },
  },
  icons: {
    iconfont: "fa", // default - only for display purposes
  },
});
